export default __webpack_public_path__ + "static/media/WordDark.8e3f41bc.svg";